import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import ProfileUserCard from '../Profile/ProfileUserCard';
import ProfileAdditionalInfo from '../Profile/ProfileAdditionalInfo';

interface ProfileUserProps {
    mode: "ADD" | "EDIT" | "VIEW" | "PROFILE";
}
export const ProfileUser: FC<ProfileUserProps> = ({ mode }) => {

    const { email: emailById } = useParams<{ email: string }>();

    let items: string[] = ['firstname', 'lastname', 'email', 'isActive'];
    if (emailById !== undefined) items.splice(3, 0, "roles");


    return (<div className='gap-4 profile-card'>
        <ProfileUserCard
            email={emailById ?? ''}
            mode={mode}
        />
        <ProfileAdditionalInfo
            email={emailById ?? ''}
            mode={mode}
        />
    </div>
    );
}
export default ProfileUser